<template>

  <EngageWorkspaceHeader v-if="showUnifiedEngageWorkspace" title="Manage" />
  <PageHeader
    v-else
    title="Manage"
  />

  <div class="min-h-screen">

    <!-- Page-level tabs when multiple tabs are available -->
    <div v-if="manageTabs.length > 1" class="px-6 pt-4">
      <Page_Tabs
        :tabs="manageTabs"
        :initial-tab="activeTab"
        @select="activeTab = $event"
      />
    </div>

    <!-- Network Map tab -->
    <div v-if="activeTab === 'Network Map'" class="p-6">
      <NetworkMap />
    </div>

    <!-- Default Manage content -->
    <div v-else class="p-6 space-y-6">

      <!-- Project Management Section -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
        <ComponentHeader title="Project Management" />
        <div class="p-6">
          <Project_Table :grouper-columns="['project_name','action_name','appuser_name','practice_name']" />
        </div>
      </div>

      <!-- Personal Analyst Section -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
        <ComponentHeader
          title="Kairon Intelligence"
          subtitle="Generate reports, briefings, and analyses across your practices and engagements"
        />
        <div class="mx-6 mt-4 flex gap-2 p-2.5 bg-blue-50 border border-blue-200 rounded-lg">
          <svg class="w-4 h-4 text-blue-500 shrink-0 mt-px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p class="text-sm text-blue-800">
            <span class="font-medium">Analyzes</span> engagements, action items, blockers, and practice activity.
            <span class="font-medium">Does not include</span> claims, costs, risk scores, or performance metrics.
          </p>
        </div>
        <div class="p-6">
          <AnalystPanel />
        </div>
      </div>

      <!-- Survey Summary Section -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
        <ComponentHeader title="Survey Summary" />
        <div class="p-6">
          <Page_Tabs
            :tabs="['Response Overview', 'LLM Summaries']"
            :initial-tab="surveyTab === 'aggregate' ? 'Response Overview' : 'LLM Summaries'"
            @select="surveyTab = $event === 'Response Overview' ? 'aggregate' : 'details'"
          />
          <div class="mt-4">
            <SurveyAggregate v-if="surveyTab === 'aggregate'" />
            <SurveyQuestionSummaryTable v-else :auto-height="true" />
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>

import Project_Table from "@/components/Lists/Project_Table.vue";
import AnalystPanel from '@/components/PersonalAnalyst/AnalystPanel.vue';
import SurveyQuestionSummaryTable from '@/components/Lists/SurveyQuestionSummary_Table.vue';
import SurveyAggregate from '@/components/Lists/SurveyAggregate.vue';
import PageHeader from '../widgetcomponents/library/PageHeader.vue';
import ComponentHeader from '../widgetcomponents/library/ComponentHeader.vue';
import Page_Tabs from '../widgetcomponents/Page_Tabs.vue';
import { defineAsyncComponent } from 'vue';
import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';
import { POSTHOG_FLAGS } from '@/constants/posthogFlags';
import { isPostHogFlagEnabled } from '@/utils/posthogFlags';
import EngageWorkspaceHeader from '@/components/navigation/EngageWorkspaceHeader.vue';
const NetworkMap = defineAsyncComponent(() => import('@/components/NetworkMap/NetworkMap.vue'));

export default {
  components: {
    Project_Table,
    AnalystPanel,
    SurveyQuestionSummaryTable,
    SurveyAggregate,
    PageHeader,
    ComponentHeader,
    Page_Tabs,
    NetworkMap,
    EngageWorkspaceHeader,
  },
  data() {
    return {
      surveyTab: 'aggregate',
      activeTab: 'Overview',
    }
  },
  computed: {
    showUnifiedEngageWorkspace() {
      return isPostHogFlagEnabled(POSTHOG_FLAGS.UNIFIED_ENGAGE_WORKSPACE);
    },
    manageTabs() {
      const tabs = ['Overview'];
      if (canAccessFeature(FEATURES.MODULE_NETWORK_MAP)) {
        tabs.push('Network Map');
      }
      return tabs;
    },
  },
  watch: {
    manageTabs(tabs) {
      if (!tabs.includes(this.activeTab)) {
        this.activeTab = 'Overview';
      }
    },
  },
}
</script>
